import React, { useState, useEffect } from "react";
import { collection, getDocs, addDoc, query, orderBy, limit } from "firebase/firestore";
import { db } from "../App";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Button, Modal, Form } from "react-bootstrap";

const AssetRegister = () => {
  const [assets, setAssets] = useState([]);
  const [newAsset, setNewAsset] = useState({
    assetName: "",
    location: "",
    manufacturer: "",
    modelSerialNo: "",
    installDate: "",
    lastServiceDate: "",
    nextServiceDate: "",
    status: "",
    notes: "",
  });
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const fetchAssets = async () => {
      const querySnapshot = await getDocs(collection(db, "asset_register"));
      const assetsList = querySnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() }));
      setAssets(assetsList.reverse());
    };
    fetchAssets();
  }, []);

  const generateAssetID = async () => {
    const assetQuery = query(collection(db, "asset_register"), orderBy("assetID", "desc"), limit(1));
    const querySnapshot = await getDocs(assetQuery);
    if (!querySnapshot.empty) {
      const lastID = querySnapshot.docs[0].data().assetID;
      const newID = parseInt(lastID, 10) + 1;
      return newID.toString().padStart(5, "0");
    } else {
      return "00001";
    }
  };

  const handleAddAsset = async () => {
    try {
      const newID = await generateAssetID();
      const assetToAdd = { ...newAsset, assetID: newID };
      await addDoc(collection(db, "asset_register"), assetToAdd);
      setAssets([...assets, assetToAdd]);
      setNewAsset({
        assetName: "",
        location: "",
        manufacturer: "",
        modelSerialNo: "",
        installDate: "",
        lastServiceDate: "",
        nextServiceDate: "",
        status: "",
        notes: "",
      });
      setShowModal(false);
    } catch (error) {
      console.error("Error adding asset: ", error);
    }
  };

  const columns = [
    { field: "assetID", headerName: "Asset ID", width: 120 },
    { field: "assetName", headerName: "Asset Name", width: 200 },
    { field: "location", headerName: "Location", width: 150 },
    { field: "manufacturer", headerName: "Manufacturer", width: 150 },
    { field: "modelSerialNo", headerName: "Model/Serial No.", width: 200 },
    { field: "installDate", headerName: "Install Date", width: 150 },
    { field: "lastServiceDate", headerName: "Last Service Date", width: 150 },
    { field: "nextServiceDate", headerName: "Next Service Date", width: 150 },
    { field: "status", headerName: "Status", width: 100 },
    { field: "notes", headerName: "Notes", width: 250 },
  ];

  return (
    <div style={{ height: 600, width: "100%" }}>
      <h2>Asset Register</h2>
      
      <Button
        variant="primary"
        onClick={() => setShowModal(true)}
        className="mb-2"
      >
        Add New Asset
      </Button>
      
      <div style={{ height: 350, width: 1150 }}>
        <DataGrid
          getRowId={(row) => row.assetID}
          rows={assets}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10, 20, 50]}
          disableSelectionOnClick
          style={{ backgroundColor: "white" }}
          components={{ Toolbar: GridToolbar }}
        />
      </div>
      

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Asset</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group>
              <Form.Label>Asset Name</Form.Label>
              <Form.Control
                type="text"
                value={newAsset.assetName}
                onChange={(e) => setNewAsset({ ...newAsset, assetName: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Location</Form.Label>
              <Form.Control
                type="text"
                value={newAsset.location}
                onChange={(e) => setNewAsset({ ...newAsset, location: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Manufacturer</Form.Label>
              <Form.Control
                type="text"
                value={newAsset.manufacturer}
                onChange={(e) => setNewAsset({ ...newAsset, manufacturer: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Model/Serial No.</Form.Label>
              <Form.Control
                type="text"
                value={newAsset.modelSerialNo}
                onChange={(e) => setNewAsset({ ...newAsset, modelSerialNo: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Install Date</Form.Label>
              <Form.Control
                type="date"
                value={newAsset.installDate}
                onChange={(e) => setNewAsset({ ...newAsset, installDate: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Last Service Date</Form.Label>
              <Form.Control
                type="date"
                value={newAsset.lastServiceDate}
                onChange={(e) => setNewAsset({ ...newAsset, lastServiceDate: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Next Service Date</Form.Label>
              <Form.Control
                type="date"
                value={newAsset.nextServiceDate}
                onChange={(e) => setNewAsset({ ...newAsset, nextServiceDate: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Status</Form.Label>
              <Form.Control
                type="text"
                value={newAsset.status}
                onChange={(e) => setNewAsset({ ...newAsset, status: e.target.value })}
              />
            </Form.Group>
            <Form.Group>
              <Form.Label>Notes</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={newAsset.notes}
                onChange={(e) => setNewAsset({ ...newAsset, notes: e.target.value })}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button variant="primary" onClick={handleAddAsset}>
            Save Asset
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AssetRegister;